import { useState, useEffect } from 'react';

/**
 * useOrientation - Detects device orientation for responsive layouts
 *
 * Per GCHL Brand Guide:
 * - Portrait: Show summary leaderboard view
 * - Landscape: Show full scorecard view
 *
 * @returns {Object} - { isLandscape, isPortrait, orientation }
 */
export const useOrientation = () => {
  const [orientation, setOrientation] = useState(() => {
    if (typeof window === 'undefined') return 'portrait';
    return window.matchMedia('(orientation: landscape)').matches ? 'landscape' : 'portrait';
  });

  useEffect(() => {
    const mediaQuery = window.matchMedia('(orientation: landscape)');

    const handleChange = (e) => {
      setOrientation(e.matches ? 'landscape' : 'portrait');
    };

    // Set initial value
    setOrientation(mediaQuery.matches ? 'landscape' : 'portrait');

    // Add listener
    mediaQuery.addEventListener('change', handleChange);

    // Cleanup
    return () => mediaQuery.removeEventListener('change', handleChange);
  }, []);

  return {
    isLandscape: orientation === 'landscape',
    isPortrait: orientation === 'portrait',
    orientation,
  };
};

export default useOrientation;
